import {
  STUDENT_TO_ASSIGN_LOAD,
  DISTRIBUTE_STUDENTS_PATCH,
  SET_SIMULATION_RESULT
} from '../actions/types';

const initialState = {
  studentsToAssign: {
    classList: [],
    classTemp: "",
    totalStudentCount: 0,
  },
  distributedResult: [],
  simulationResult: [],
};

export default function distribution(state = initialState, action) {
  switch (action.type) {
    case STUDENT_TO_ASSIGN_LOAD:
      return {
        ...state,
        studentsToAssign: action.payload,
      };
 case DISTRIBUTE_STUDENTS_PATCH:
      return {
        ...state,
        distributedResult: action.payload,
      };
    case SET_SIMULATION_RESULT:
      return {
        ...state,
        simulationResult: action.payload, 
      };
    default:
      return state;
  }
}

